<template>
  <div>
    <main class="main" role="main">
      <div class="main_con">
        <div class="my">
          <div class="my_profile">
            <div class="my_thumb">
              <div class="n_thumb">
                <div class="n_thumb_inner">
                  <img
                    :src="
                      user.photoThumb
                        ? user.photoThumb
                        : require(`@/assets/front/images/v2/profiles/img_profile_${getProfileNum(
                            user.id,
                          )}.png`)
                    "
                  />
                </div>
              </div>
            </div>
            <div class="my_info">
              <div class="my_info_inner">
                <div class="my_info_place">
                  <button class="btn_place" @click.prevent="gotoRegion">
                    {{ user.emdAreaNameShort }}
                  </button>
                </div>
                <h1 class="pnt" v-on:click="gotoProfile">
                  {{ user.nickname }}<span></span>
                </h1>
              </div>
            </div>
          </div>
          <div class="my_mid_area">
            <ul>
              <li class="pnt" v-on:click="gotoList">
                <div class="icon">
                  <img src="@/assets/front/images/new/i_my_c_list.svg" alt="" />
                </div>
                <p>인터넷 신청현황</p>
              </li>
              <li class="pnt" v-on:click="gotoPromise">
                <div class="icon">
                  <img
                    src="@/assets/front/images/new/i_my_c_promise.svg"
                    alt=""
                  />
                </div>
                <p>휴대폰 신청현황</p>
              </li>
              <!-- <li v-on:click="gotoEstimationManage">
                <div class="icon">
                  <img src="@/assets/front/images/new/i_my_c_docu.svg" alt="" />
                </div>
                <p>요청서 관리</p>
              </li> -->
            </ul>
          </div>
          <div class="my_menu_sec first">
            <ul class="icon">
              <li class="pnt ic_favorite" v-on:click="gotoFavorite">
                관심 매장
              </li>
              <!-- <li class="pnt ic_internet_bookmark" v-on:click="gotoInternetBookmark">
                찜한 인터넷 요금제
              </li> -->
              <li
                class="pnt ic_mobile_bookmark"
                v-on:click="gotoMobileBookmark"
              >
                찜한 휴대폰
              </li>
            </ul>
          </div>
          <div class="my_menu_sec">
            <ul class="icon">
              <li class="pnt ic_notification" v-on:click="gotoNotification">
                알림설정
              </li>
              <li class="pnt ic_email" v-on:click="gotoEmail">이메일 등록</li>
              <li class="pnt ic_cache_del" v-on:click="gotoCacheDel">
                캐시 삭제 (채팅 오류)
              </li>
            </ul>
          </div>
          <div class="my_menu_sec">
            <ul class="icon">
              <li class="pnt ic_notice" v-on:click="gotoNotice">공지사항</li>
              <li class="pnt ic_faq" v-on:click="gotoFAQ">
                자주 묻는 질문
              </li>
              <li
                class="inquiry_list pnt ic_inquiry"
                v-on:click="gotoSystemInquiry"
              >
                1:1 문의(고객센터)
                <div class="icon_new" v-if="checkNewReplyCnt > 0">
                  <i class="i_new"></i>
                </div>
              </li>
            </ul>
          </div>
          <div class="my_menu_sec">
            <ul>
              <li class="pnt" v-on:click="goTerms('agreement', '약관정보')">
                약관정보
              </li>
              <li
                class="pnt"
                v-on:click="goTerms('personal', '개인정보취급방침')"
              >
                개인정보취급방침
              </li>
              <li
                class="pnt"
                v-on:click="goTerms('geolocation', '위치기반서비스 이용약관')"
              >
                위치기반서비스 이용약관
              </li>
            </ul>
          </div>
          <div class="my_menu_sec">
            <ul class="icon">
              <li class="logout pnt" v-on:click="logout">
                로그아웃
              </li>
            </ul>
          </div>
        </div>
      </div>
      <DesignPopup2
        :show="designPopup"
        :data="{
          title: '',
          type: 'confirm',
          msg: `앱 내 캐시 삭제를 통해 채팅이 안 보이는<br />증상을 해결 할 수 있습니다.<br /><br />삭제할까요?<br /><br />(채팅 메시지는 자동 복원 됩니다.)`,
          btn_1: '닫기',
          btn_2: '삭제하기',
        }"
        @close="popupClose"
      />
    </main>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import UrlSwitch from '@/common/components/UrlSwitch.vue';
import { authMapActions, authTypes } from '@common/store/modules';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as commonMapActions,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonTypes from '@common/store/modules/common/types';

import {
  mapActions as chatMapActions,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatTypes from '@common/store/modules/chat/types';

import {
  isApp,
  nativeShareText,
  sleep,
  nativeDeviceInfo,
  nativeKakaoLogout,
} from '@common/lib/common/utils';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  components: {
    DesignPopup2,
  },
  data() {
    return {
      myDeviceName: '',
      myTelecomName: '',
      designPopup: false,
      checkNewReplyCnt: 0,
    };
  },
  async created() {
    this.getMyProfile();
    this.updateChatMemberScreenActivedAll();
    await this.getDevice();

    const checkNewReply = await this[
      chatTypes.FETCH_CHATMESSAGE_CHECKNEWREPLY
    ]();

    this.checkNewReplyCnt = checkNewReply.newCount;
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
  },
  methods: {
    ...authMapActions([authTypes.LOGOUT]),
    ...userMapActions([
      userTypes.FETCH_ME,
      userTypes.UPDATE_USER_TELECOM_AND_DEVICE,
    ]),
    ...commonMapActions([commonTypes.SET_DIALOG, commonTypes.HIDE_DIALOG]),
    ...chatMapActions([
      chatTypes.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
      chatTypes.RESET_CHAT_CACHE,
      chatTypes.FETCH_CHATMESSAGE_CHECKNEWREPLY,
    ]),
    gotoProfile() {
      this.$router.push({ name: 'MyPage.Profile' });
    },
    gotoEmail() {
      this.$router.push({ name: 'MyPage.Email' });
    },
    gotoEstimationManage() {
      this.$router.push({ name: 'Estimation.Manage' });
    },
    gotoFavorite() {
      this.$router.push({ name: 'MyPage.Favorite' });
    },
    gotoInternetBookmark() {
      this.$router.push({ name: 'MyPage.InternetBookmarkPlan' });
    },
    gotoMobileBookmark() {
      this.$router.push({ name: 'MyPage.MobileBookmarkPlan' });
    },
    gotoPromise() {
      this.$router.push({ name: 'Mobile.ApplyList' });
    },
    gotoList() {
      this.$router.push({ name: 'Apply.Main' });
    },
    gotoCacheDel() {
      this.designPopup = true;
    },
    gotoRegion() {
      let codeType = 'e';
      let areaId = this.user.emdAreaId;
      if (this.user.admName) {
        const admArea = JSON.parse(this.user.admName);
        areaId = admArea.id;
        codeType = 'a';
      }
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          //areaName: this.user.emdAreaName.split(' ')[2],
          areaName: this.user.emdAreaName.substring(
            this.user.emdAreaName.lastIndexOf(' ') + 1,
          ),
          areaFullName: this.user.emdAreaName,
          areaId,
          codeType,
          from: 'MyPage',
        },
      });
    },
    gotoNotification() {
      this.$router.push({ name: 'MyPage.Notification' });
    },
    gotoNotice() {
      this.$router.push({
        name: 'MyPage.Notice',
        query: { boardId: 'NOTICE_CUSTOMER' },
      });
    },
    gotoSystemInquiry() {
      this.$router.push({ name: 'MyPage.SystemInquiry' });
    },
    gotoFAQ() {
      this.$router.push({
        name: 'MyPage.FAQ',
        query: { boardId: 'FAQ_CUSTOMER' },
      });
    },
    goTerms(type, title) {
      this.$router.push({
        name: 'Agreement.Terms',
        params: { type: type, title: title },
      });
    },
    goSupportCusLink() {
      window.open('http://pf.kakao.com/_WgAXb/chat', '_blank');
    },
    logout() {
      this[commonTypes.SET_DIALOG]({
        type: 'confirm',
        icon: 'warning',
        message: `로그아웃하시겠습니까?`,
        okCb: async () => {
          this[authTypes.LOGOUT]().then(() => {
            // nativeKakaoLogout(); // 안드로이드 앱은 처리 했음
            // 카카오 로그아웃
            this.kakaoLogout();

            this.$router.push({
              name: 'Auth.Login',
              query: { isRoot: '1' },
            });
          });
        },
      });
    },
    kakaoLogout() {
      if (!window.Kakao.Auth.getAccessToken()) {
        console.log('not logged in');
        return;
      }
      // 그냥 로그아웃
      window.Kakao.Auth.logout(function() {
        console.log('카카오 로그아웃 성공', window.Kakao.Auth.getAccessToken());
      });
      // 연결 자체를 끊기
      // window.Kakao.API.request({
      //   url: '/v1/user/unlink',
      //   success: function(res) {
      //     console.log('logout res :: {}', res);
      //   },
      //   fail: function(err) {
      //     console.log('logout err :: {}', err);
      //   },
      // });
    },
    async getMyProfile() {
      this[userTypes.FETCH_ME]();
    },
    async updateChatMemberScreenActivedAll() {
      this[chatTypes.UPDATE_MEMBER_SCREEN_ACTIVED_ALL]({
        actived: false,
      });
    },
    async getDevice() {
      nativeDeviceInfo();
      await sleep(500);
      this.myDeviceName = window.$bridge.deviceModelName || '';
      this.myTelecomName = window.$bridge.telecomName || '';

      // 로그인 후 디바이스 정보 저장
      // if (this.myDeviceName != '' || this.myTelecomName != '') {
      //   let td_param = {
      //     id: this.user.id,
      //     deviceModelName: this.myDeviceName,
      //     telecomName: this.myTelecomName,
      //   };
      //   this[userTypes.UPDATE_USER_TELECOM_DEVICE](td_param);
      // }

      if (this.myDeviceName != '' || this.myTelecomName != '') {
        let td_param = {
          id: this.user.id,
          deviceName: this.myDeviceName,
          deviceModelName: '',
          telecomName: this.myTelecomName,
        };
        this[userTypes.UPDATE_USER_TELECOM_AND_DEVICE](td_param);
      }
    },
    async popupClose(checked) {
      if (checked) {
        // 채팅 초기화
        let resetChatCacheList = [];

        resetChatCacheList = await this[chatTypes.RESET_CHAT_CACHE]();

        console.log(resetChatCacheList);

        console.log(resetChatCacheList.length);

        if (resetChatCacheList.length > 0) {
          for (const uuid of resetChatCacheList) {
            console.log(uuid);
            localStorage.removeItem(`perce-chatroom-${uuid}`);
          }
        }
      }
      this.designPopup = false;
    },
    getProfileNum(userId) {
      return util.setProfile(userId);
    },
  },
};
</script>
